import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectRole, setFrequency } from "./infoSlice";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { useMemo } from "react";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";
import TrackContainer from "./TrackContainer";

const FrequencyTrack = ({ history }) => {
  const { t } = useTranslation();
  const role = useSelector(selectRole);
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const frequencyOptions = useMemo(() => {
    switch (role) {
      case "Partner":
      case "Kid":
      case "Friend":
      case "Sibling":
      case "Grandparent":
      default:
        return [
          {
            id: 0,
            imgPath: ('../assets/how_frequently/real_time.png'),
            name: t("real_time_updates"),
            value: "Realtime"
          },
          {
            id: 1,
            imgPath: ('../assets/how_frequently/every_five_minutes.png'),
            name: t("every5_minutes"),
            value: "5mins"
          },
          {
            id: 2,
            imgPath: ('../assets/how_frequently/every_fifteen_minutes.png'),
            name: t("every15_minutes"),
            value: "15mins"
          },
          {
            id: 3,
            imgPath: ('../assets/how_frequently/every_hour.png'),
            name: t("every_hour"),
            value: "Hourly"
          },
          {
            id: 4,
            imgPath: ('../assets/how_frequently/other.png'),
            name: t("other"),
            value: "Other"
          },
        ];
    }
  }, [t, role]);

  const onSingleClick = (howFrequently) => {
    dispatch(setEventData({ id: "Updates", data: howFrequently }));
    const frequencyOption = frequencyOptions.find((option) => option.value === howFrequently);
    dispatch(setFrequency(frequencyOption?.name));
    sendAnalyticsEvents(EVENTS.onboardingUpdatesSubmitted, {
      ...eventsData,
      Updates: howFrequently,
    });
    history.push(`/choose-location-type`);
  };

  return (
    <TrackContainer
      pageEvent={"onboardingUpdatesShown"}
      title={t("question5_title")}
      options={frequencyOptions}
      onSingleClick={onSingleClick}
      nextPage={'choose-location-type'}
    />
  );
};

export default FrequencyTrack;
